import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="border-b border-crema bg-blanco" data-id="element-41" data-mp="1nwvwmzb64jqt">
      <div className="mx-auto max-w-2xl px-4 py-6 sm:py-9" data-id="element-42" data-mp="2bkvsuer912cs">
        <SectionHeader id="faq" title="Preguntas frecuentes" data-id="element-43" data-mp="2fm7cm3nfytd2" />
        <div className="mt-3 space-y-1.5" data-id="element-44" data-mp="2fns5zpy0s69c">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className={`rounded-xl border bg-crema/40 transition-colors duration-150 ease-soft ${isOpen ? 'border-petroleo/60' : 'border-crema'}`} data-id="element-45" data-mp="26slxgj7d7a34" data-mpi={i}>
                <h3 data-id="element-46" data-mp="2zbrknbvpfxk1">
                  <button type="button" id={`faq-trigger-${i}`} onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-3 rounded-xl px-3 py-2.5 text-left" data-id="element-47" data-mp="1vpht7ww1rnrs">
                    <span className="text-sm font-bold text-azul" data-id="element-48" data-mp="2fdic0p0of6ku">{faq.q}</span>
                    <ChevronDownIcon size={16} aria-hidden="true" className={`flex-shrink-0 text-terracota transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} data-id="element-49" data-mp="2ffl6bl8v3lvd" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-50" data-mp="u0xku44k47la">
                  {isOpen && <motion.div id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-trigger-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-51" data-mp="p2mcxyxto75p">
                      <p className="px-3 pb-2.5 text-[0.8rem] leading-snug text-azul/80 sm:text-sm" data-id="element-52" data-mp="3837x9bnenplt">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}